module.exports = __webpack_public_path__ + "static/media/family-2.6432cf2b.png";